import React, { useState } from "react"
import CapsuleSmall from "../svg/Capsule-Small"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import SearchIcon from "../svg/icons/searchIcon"
import NavBarHamburgerMenu from "../NavBarMobileMenu"
import LanguageSwitcher from "@/components/LanguageSwitcher"
import useMenuToggle from "@/hooks/useMenuToggle"
import useIsMobile from "@/hooks/useIsMobile"
import { gtmTracking } from "@/utils/gtm-tracking"

const IntegrationNavigation = ({
  searchTerm,
  setSearchTerm,
  availableSlugs,
}) => {
  const { t } = useTranslation()
  const [showMenu, setShowMenu] = React.useState(null)
  const [isNavigationOpen, setIsNavigationOpen] = React.useState(false)

  const setSearch = term => {
    setSearchTerm(term)
  }

  const toggleNavigation = () => {
    setIsNavigationOpen(prev => !prev)
  }

  const integrationNavRef = React.useRef()

  const { handleToggle } = useMenuToggle(setShowMenu)
  const isMobile = useIsMobile()

  return (
    <div
      className={`integration-navigation__wrapper ${
        isNavigationOpen ? "integration-navigation__wrapper--open" : ""
      }`}
      ref={integrationNavRef}
    >
      <div className="integration-navigation__container">
        <Link to={"/"} className="integration-navigation__logo">
          <CapsuleSmall />
        </Link>
        <h2 className="mb-0 h5 integration-navigation__title">
          {t("integrations.navigation.title")}
        </h2>
        <NavBarHamburgerMenu onToggle={toggleNavigation} />
      </div>
      {setSearchTerm && (
        <div className="integration-navigation__container">
          <form className="integration-navigation__search">
            <input
              type="text"
              placeholder={t("integrations.navigation.search-integrations")}
              id="integrationSearch"
              className="integration-navigation__search-input"
              value={searchTerm}
              onChange={e => setSearch(e.target.value)}
            />
            <div className="integration-navigation__search-button">
              <SearchIcon />
            </div>
          </form>
        </div>
      )}

      <div className="integration-navigation__container">
        <nav className="integration-navigation__nav">
          <div
            className={
              isMobile
                ? "language-switcher--mobile"
                : "language-switcher--desktop"
            }
          >
            {(availableSlugs === null ||
              (Array.isArray(availableSlugs) && availableSlugs.length > 1)) && (
              <LanguageSwitcher
                availableSlugs={availableSlugs ?? []}
                showMenu={showMenu}
                setShowMenu={() => handleToggle("language")}
              />
            )}
          </div>
          <Link to="/partner-program/technology/" className="a">
            {t("integrations.navigation.technology")}
          </Link>

          <a
            href="https://app.capsulecrm.com/siteaddress/goto"
            onClick={() =>
              gtmTracking("Login Click", "Integration Login", "")()
            }
          >
            {t("integrations.navigation.login")}
          </a>
          <Link
            to="/signup/"
            className="btn"
            onClick={() =>
              gtmTracking("Top Nav Click", "Try Free", "Integration page")()
            }
          >
            {t("integrations.navigation.try-capsule")}
          </Link>
        </nav>
      </div>
    </div>
  )
}

export default IntegrationNavigation
